import { ReactElement } from 'react';
import { BrandedStoreSlice } from '@adapters/prismic/types/brandedStorePage';
import { PageType } from '@adapters/prismic/types/slices';
import { AlgonomyPlacement } from '@components/global/Recommendations/Loader';
import CategoryPageSliceHandler from '../CategoryPageSliceHandler';
import { HomepageSlice } from '@adapters/prismic/types/homepage';

import styles from './CategoryPageSliceZone.module.scss';

export interface BrandedStoreSliceZoneProps {
  slices?: BrandedStoreSlice[] | HomepageSlice[];
  categoryPageRecommendations?: AlgonomyPlacement[];
  isEnhancedPlp?: boolean;
}

const CategoryPageSliceZone = ({
  slices,
  categoryPageRecommendations,
}: BrandedStoreSliceZoneProps): ReactElement => (
  <div>
    {slices?.map((slice: BrandedStoreSlice | HomepageSlice, i: number) => (
      <section
        key={`category-page-slice-${slice?.id}`}
        className={styles.slice}
      >
        <CategoryPageSliceHandler
          slice={slice}
          pageType={PageType.categoryInfoPage}
          sliceIndex={i}
          recommendations={categoryPageRecommendations}
        />
      </section>
    ))}
  </div>
);

export default CategoryPageSliceZone;
